module.exports = __webpack_public_path__ + "img/me_daishenhe_icon@2x.c40e3426.png";